//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "common-loading",
    data() {
        return {
            txt: "加载中...",
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/loading.vue